import { render, staticRenderFns } from "./ListagemEnvios.vue?vue&type=template&id=54d43004&scoped=true"
import script from "./ListagemEnvios.vue?vue&type=script&lang=js"
export * from "./ListagemEnvios.vue?vue&type=script&lang=js"
import style0 from "./ListagemEnvios.vue?vue&type=style&index=0&id=54d43004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d43004",
  null
  
)

export default component.exports